import React, { useEffect, useState } from 'react';

import CSSModules from 'react-css-modules';
import { Form } from 'react-final-form';
import { injectIntl } from 'react-intl';
import { connect, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { AppWrapper, Block, Button, Spinner } from 'components';
import AdminBusinessUserForm from 'components/AdminBusinessUserForm/AdminBusinessUserForm';
import AdminCustomerUserForm from 'components/AdminCustomerUserForm/AdminCustomerUserForm';
import Breadcrumbs from 'components/BreadCrumbs/BreadCrumbs';
import AuthProtected from 'containers/AuthProtected/AuthProtected';
import { actions as fetchUsersDataActions } from 'coupon-common/src/modules/admin/userManager/fetchUsersData';
import { actions as userDetailActions } from 'coupon-common/src/modules/admin/userManager/getUserDetails'
import { actions as updateUserInfoActions } from 'coupon-common/src/modules/admin/userManager/updateUserInfo'
import { actions as membershipActions } from 'coupon-common/src/modules/memberships/plans'

import styles from './EditUser.module.scss';

const EditUser = ({ dispatch, usersData, businessCategories, membership_plans, cities, updateUserData, updateUserError, userDetails }) => {

  const { id } = useParams();
  const user = usersData?.find(user => user?.id === Number(id));

  const [isEditing, setIsEditing] = useState(false);
  const [allCategories, setAllCategories] = useState([])
  const [updatedUser, setUpdatedUser] = useState(user)
  const [apiCall, setApiCall] = useState(false)
  const [submittedUserData, setSubmittedUserData] = useState(null)

  useEffect(() => {
    dispatch(membershipActions.getMembershipPlans());

    dispatch(userDetailActions.getUserDetails(id));

  }, [id])

  useEffect(() => {
    if (userDetails) {

      transformUserData(userDetails);
    }
  }, [userDetails]);


  useEffect(() => {

    if (apiCall) {
      if (updateUserData?.success) {
        setUpdatedUser(submittedUserData)
        alert("User information has been updated successfully.")
        setApiCall(false)
        // After successful updation of user data fetch the latest data
        dispatch(userDetailActions.getUserDetails(id));
        dispatch(fetchUsersDataActions.getAllUsers());
      }
      else if (updateUserError) {
        alert("There was an error updating the user information.")
        setApiCall(false)
      }
    }

  }, [updateUserData, updateUserError])

  const transformUserData = (userData) => {

    const parseDate = (dateString) => {
      if (!dateString) return null;
      const parsedDate = new Date(dateString).toISOString().slice(0, 16);
      return parsedDate;
    };

    const transformed = {
      ...userData,
      signed_at: parseDate(userData?.signed_at),
      wallet: {
        ...userData.wallet,
        points_recalculation_date: parseDate(userData?.wallet?.points_recalculation_date),
      },
      membership: {
        ...userData.membership,
        ...(userData.membership?.created_at !== undefined
          ? { created_at: parseDate(userData?.membership?.created_at) }
          : {}),
        date_start: parseDate(userData?.membership?.date_start),
        expiration_date: parseDate(userData?.membership?.expiration_date),
      },
    };

    setUpdatedUser(transformed);
    filterCategories(userData);

  };

  const filterCategories = (userData) => {
    const userCategoryIds = new Set(userData?.categories);
    const updatedUserCategories = [];
    const updatedAllCategories = [];

    for (const key in businessCategories?.entities?.businessCategories) {
      const category = businessCategories.entities.businessCategories[key];

      updatedAllCategories.push(category);

      if (userCategoryIds.has(Number(key))) {
        updatedUserCategories.push(category);
      }
    }

    setAllCategories(updatedAllCategories);
    setUpdatedUser((prevUser) => ({
      ...prevUser,
      categories: updatedUserCategories
    }))

  }


  const toggleEdit = () => {
    setIsEditing(true);
  };

  const cancelEdit = (form) => {
    form.reset();
    setIsEditing(false);
  };

  const handleSave = (event, submitCallback) => {
    event.preventDefault()
    const confirmSave = window.confirm("Are you sure you want to save the changes ?")
    if (confirmSave) {
      setIsEditing(false);
      submitCallback()
    }
  }

  // if (!user) {
  //   return <Spinner show/>;
  // }

  return (
    <AppWrapper showHeader showSideNav showHeadingRow headingText="Edit User">
      <AuthProtected />
      <Block className={"w-100"}>
        {!user ? <Spinner show/> : (
          <>
            <Breadcrumbs locationArray={["Admin", "User Manager", "Edit"]} />
            <Form
              initialValues={updatedUser}
              onSubmit={(values, form) => {
                setSubmittedUserData(values)
                const initialValues = updatedUser; // The original user data
                const changedFields = {};

                const findChanges = (newData, oldData) => {
                  if (typeof newData === 'object' && newData !== null) {
                    Object.keys(newData).forEach((key) => {
                      if (typeof newData[key] === 'object' && newData[key] !== null) {

                        if (key === "categories") {
                          if (newData[key] !== oldData[key]) {
                            changedFields[key] = newData[key]?.map((category) => category.id)
                            return
                          }
                        }
                        // Nested objects
                        Object.keys(newData[key]).forEach((innerKey) => {
                          if (newData[key][innerKey] !== oldData[key]?.[innerKey]) {
                            changedFields[key] = { ...changedFields[key], [innerKey]: newData[key][innerKey] };
                          }
                        });
                      }
                      else {
                        if (newData[key] !== oldData[key]) {
                          changedFields[key] = newData[key]
                        }

                      }
                    });
                  }
                };

                findChanges(values, initialValues);


                if (Object.keys(changedFields).length > 0) {
                  if (updatedUser?.is_business) {
                    dispatch(updateUserInfoActions.updateBusinessUser(updatedUser.id, changedFields));
                  } else {
                    dispatch(updateUserInfoActions.updateCustomerUser(updatedUser.id, changedFields));
                  }
                  setApiCall(true)
                }
              }}
              render={({ handleSubmit, form }) => {
                return (
                  <form onSubmit={handleSubmit}>
                    <div styleName="buttonGroup">
                      {isEditing && (
                        <Button
                          small
                          outline
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            cancelEdit(form); // Pass the form instance
                          }}
                        >
                          Cancel
                        </Button>
                      )}
                      {isEditing ? (
                        <Button small primary type="button" onClick={(e) => handleSave(e, handleSubmit)}>
                          Save
                        </Button>
                      ) : (
                        <Button small primary type="button" onClick={toggleEdit}>
                          Edit
                        </Button>
                      )}

                    </div>
                    {user?.is_business ? (
                      <AdminBusinessUserForm styles={styles} membership_plans={membership_plans} isEditing={isEditing} allCategories={allCategories} cities={cities} user={updatedUser} />
                    ) : (
                      <AdminCustomerUserForm styles={styles} isEditing={isEditing} allCategories={allCategories} cities={cities} user={updatedUser} />
                    )}
                  </form>
                )
              }}
            />
          </>
        )}
      </Block>
    </AppWrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    usersData: state.admin.userManager.fetchUsersData.data,
    updateUserData: state.admin.userManager.updateUserInfo.data,
    updateUserError: state.admin.userManager.updateUserInfo.error,
    businessCategories: state.businessCategories,
    membership_plans: state.memberships.plans.data,
    cities: state.locations.entities.cities,
    userDetails: state.admin.userManager.getUserDetails.data,
  };
};

export default connect(mapStateToProps)(injectIntl(CSSModules(EditUser, styles)));